import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { event as trackEvent } from "@/utils/analytics";
import { SINGLE_LETTER_ANALYTICS_VALUE } from "@/utils/publicPrices";

export default function Success() {
  const location = useLocation();

  useEffect(() => {
    // Extrai parâmetros da URL se necessário, por exemplo, o ID da sessão do Stripe
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get('session_id'); // Exemplo, se você passar o ID

    // Envia o evento de compra para o Google Analytics
    trackEvent({
      action: 'purchase',
      params: {
        transaction_id: sessionId || `txn-${Date.now()}`,
        // Retorno da carta avulsa (/sucesso). O Premium anual é R$ 29,90/ano e volta em /admin/conta.
        value: SINGLE_LETTER_ANALYTICS_VALUE,
        currency: 'BRL',
      }
    });
  }, [location]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full mx-auto bg-white rounded-2xl shadow-lg p-8">
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <div className="bg-green-100 p-4 rounded-full">
              <CheckCircle className="h-12 w-12 text-green-600" />
            </div>
          </div>
          
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-gray-900">
              Pagamento Confirmado!
            </h1>
            
            <p className="text-gray-600">
              Sua carta foi registrada com sucesso e será entregue na data marcada.
              Você receberá um email com a confirmação do pagamento.
            </p>
          </div>

          <div className="pt-4">
            <Link to="/">
              <Button
                variant="outline"
                className="inline-flex items-center gap-2"
              >
                <Home className="h-4 w-4" />
                Voltar para página inicial
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}